import { render, staticRenderFns } from "./IgaParameterNode.vue?vue&type=template&id=cf7f0aee&scoped=true&"
import script from "./IgaParameterNode.vue?vue&type=script&lang=js&"
export * from "./IgaParameterNode.vue?vue&type=script&lang=js&"
import style0 from "./IgaParameterNode.vue?vue&type=style&index=0&id=cf7f0aee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7f0aee",
  null
  
)

export default component.exports